import React, { useEffect, useState } from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import { auth } from './firebase';

const Home = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <h1 className="main-title">Secure the Digital Future with Echelon</h1>

        <div className="video-container">
          <iframe 
            className="featured-video"
            src="https://www.youtube.com/embed/QKsqVWUerwY" 
            title="Introduction to Echelon Cybersecurity NGO"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen>
          </iframe>
        </div>

        {/* Video Description */}
        <div className="video-description">
          <h2 className="section-title">About Our Mission</h2>
          <p className="video-text">
            Curious about how you can make a real impact in the world of cybersecurity while earning volunteer hours?
            <br /><br />
            In this video, Vedasai Vanniya and Jeremiah Kim introduce you to our nonprofit organization dedicated to promoting cybersecurity awareness, digital safety, and ethical tech practices in our communities.
            <br /><br />
            Learn how you can get involved, gain hands-on experience, and make a difference—whether you're a tech enthusiast or just getting started. Hit play to discover how volunteering with us can empower your future and protect others online!
          </p>
        </div>

        <Link to={user ? "/VolunteerHours" : "/Register"}>
          <button className="cta-button">Become a Volunteer</button>
        </Link>
      </section>

      {/* Highlights Section */}
      <section className="highlights-section">
        <h2 className="section-title">Why Join Echelon?</h2>
        <div className="highlights-grid">
          <div className="highlight-card">
            <img src="./photo1.jpg" alt="Hands-on Experience" className="highlight-image" />
            <h3>Hands-on Experience</h3>
            <p>Gain practical cybersecurity skills through quizzes and meetings.</p>
          </div>
          <div className="highlight-card">
            <img src="./photo2.jpg" alt="Community Impact" className="highlight-image" />
            <h3>Community Impact</h3>
            <p>Make a tangible difference by helping protect vulnerable groups from cyber threats.</p>
          </div>
          <div className="highlight-card">
            <img src="./photo3.jpg" alt="Career Development" className="highlight-image" />
            <h3>Career Development</h3>
            <p>Build your resume with volunteer hours and networking opportunities.</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <h2 className="section-title">What Our Volunteers Say</h2>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <p>"Echelon gave me the confidence to further spread awareness on cybersecurity."</p>
            <div className="testimonial-author">
              <img src="./profile.png" alt="Alexandra" className="author-avatar" />
              <span> Aryan V, a member</span>
            </div>
          </div>
          <div className="testimonial-card">
            <p>"The interactive experience I gained here was more valuable than any classroom session."</p>
            <div className="testimonial-author">
              <img src="profile.png" alt="James" className="author-avatar" />
              <span>Rohan T, A volunteer</span>
            </div>
          </div>
        </div>
      </section>

      {/* Call-to-Action Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Make a Difference?</h2>
          <p className="cta-text">Join our growing community of cybersecurity volunteers today.</p>
          <div className="cta-buttons">
            <Link to={user ? "/VolunteerHours" : "/Register"}>
              <button className="cta-button-primary">
                {user ? "Dashboard" : "Sign Up Now"}
              </button>
            </Link>
            <Link to={user ? "/ContactUs" : "/ContactUs"}>
              <button className="cta-button-secondary">Learn More</button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
